<ion-grid class="auto-plan-order" *ngIf="viewState() as state">
  <ion-row class="auto-plan-order__heading">
    <ion-col>{{ state.title }}</ion-col>
    <ion-col size="auto">
      <ion-button fill="clear" (click)="close()"> <ion-img src="/assets/icon/common/X.svg"></ion-img> </ion-button>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col size="12">
      <div class="auto-plan-order__summary">
        <div class="auto-plan-order__tile" *ngFor="let tile of state.summaryTiles">
          <div class="auto-plan-order__tile__label">{{ tile.label }}</div>
          <div class="auto-plan-order__tile__value">{{ tile.value }}</div>
        </div>
      </div>
    </ion-col>
  </ion-row>

  <ion-row *ngIf="state.unplannedOpls.length" class="auto-plan-order__warning">
    <ion-col size="12">
      <div class="auto-plan-order__warning__title">
        {{ state.unplannedOpls.length }} OPL(s) could not be planned and will not be loaded:
      </div>
      <div class="auto-plan-order__warning__item" *ngFor="let opl of state.unplannedOpls">
        <span class="auto-plan-order__warning__opl">{{ opl.oplId }}</span> - {{ opl.reason }}
      </div>
    </ion-col>
  </ion-row>

  <ion-row class="auto-plan-order__tabs">
    <ion-col size="auto">
      <ion-segment [value]="activeTab()" (ionChange)="onTabChange($event)">
        <ion-segment-button value="TABLE">
          <ion-label>Table</ion-label>
        </ion-segment-button>
        <ion-segment-button value="BOARD">
          <ion-label>LL Board</ion-label>
        </ion-segment-button>
      </ion-segment>
    </ion-col>
  </ion-row>

  <ion-row *ngIf="activeTab() === 'TABLE'" class="auto-plan-order__table">
    <ion-col size="12" class="auto-plan-order__table__scroll">
      <ui-table
        [cellSize]="'SMALL'"
        [cellTextAlign]="'middle'"
        [zTableModel]="state.planTable"
        emptyTableText="No plan suggestions available for the selected OPLs"
        (onLinkClicked)="onTableLinkClicked($event)"
      ></ui-table>
    </ion-col>
  </ion-row>

  <ng-container *ngIf="activeTab() === 'BOARD'">
    <ion-row *ngIf="focusedSuggestion() as focused" class="auto-plan-order__stepper ion-align-items-center">
      <ion-col size="auto">
        <ion-button fill="clear" [disabled]="focused.position === 1" (click)="onPrevSuggestion()">
          <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
        </ion-button>
      </ion-col>
      <ion-col size="auto" class="auto-plan-order__stepper__label">
        Suggestion {{ focused.position }} of {{ focused.total }} ·
        <span class="auto-plan-order__stepper__opl">{{ focused.suggestion.oplId }}</span> ·
        {{ focused.suggestion.lineName }} · {{ focused.suggestion.startDate }} to {{ focused.suggestion.endDate }}
      </ion-col>
      <ion-col size="auto">
        <ion-button fill="clear" [disabled]="focused.position === focused.total" (click)="onNextSuggestion()">
          <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>

    <ng-container [ngSwitch]="board().status">
      <ion-row *ngSwitchCase="'FAILED'" class="auto-plan-order__board auto-plan-order__board--message">
        <ion-col size="12">The board could not be loaded. The Table tab lists every suggestion.</ion-col>
      </ion-row>

      <ng-container *ngSwitchCase="'READY'">
        <ng-container *ngIf="board() as readyBoard">
          <ion-row
            *ngIf="readyBoard.status === 'READY' && readyBoard.isFocusedOutOfRange"
            class="auto-plan-order__warning"
          >
            <ion-col size="12">
              This suggestion starts after the furthest date the LL Board shows, so it is not drawn. See the Table tab
              for its dates.
            </ion-col>
          </ion-row>
          <ion-row class="auto-plan-order__board">
            <ion-col size="12" class="auto-plan-order__board__timeline" *ngIf="readyBoard.status === 'READY'">
              <monorepo-timeline
                [configuration]="{
                  renderType: 'LL_BOARD',
                  hideCalendarHolidays: true,
                  enableZoom: true,
                  enableHorizontalScroll: true
                }"
                [timelineModel]="readyBoard.timelineModel"
                [viewDateRange]="readyBoard.viewDateRange"
                [maxDaysToShow]="readyBoard.maxDaysToShow"
                [disableStripEvents]="true"
                [hideOpenInfoBtn]="true"
                (onTimelineUpdate)="onBoardViewChange($event)"
                (onNext)="onBoardNext()"
                (onPrev)="onBoardPrev()"
                (onToday)="onBoardToday()"
                (onZoom)="onBoardViewDateRangeChange($event)"
                (onScrollViewChange)="onBoardViewDateRangeChange($event)"
              ></monorepo-timeline>
            </ion-col>
          </ion-row>
        </ng-container>
        <ion-row class="auto-plan-order__legend">
          <ion-col size="12">
            <span class="auto-plan-order__legend__proposed"></span> Proposed by Auto Plan; the highlighted one is the
            suggestion above. Existing strips are shown where they are today; Confirm Plan may shift them to make room.
          </ion-col>
        </ion-row>
      </ng-container>

      <ion-row *ngSwitchDefault class="auto-plan-order__board auto-plan-order__board--message">
        <ion-col size="12">Loading lines...</ion-col>
      </ion-row>
    </ng-container>
  </ng-container>

  <ion-row class="ion-text-end ion-margin-top">
    <ion-col>
      <ui-custom-button buttonType="SECONDARY" btnTxt="Cancel" (clickEvent)="close()"></ui-custom-button>
      <ui-custom-button
        [isDisabled]="!state.hasPlans"
        class="ion-margin-start"
        btnTxt="Confirm Plan"
        (clickEvent)="planOrder()"
      ></ui-custom-button>
    </ion-col>
  </ion-row>
</ion-grid>
